import { useRef as Hn, useLayoutEffect as Jn, useEffect as le, useState as it, useCallback as Xn, useMemo as Qn } from "react";
function es(t) {
  const e = Hn(null);
  return e.current === null && (e.current = t()), e.current;
}
const ts = typeof window < "u", ns = ts ? Jn : le;
function ss(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function rs(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const de = (t, e, n) => n > e ? e : n < t ? t : n;
function pt(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let Be = () => {
}, ne = () => {
};
process.env.NODE_ENV !== "production" && (Be = (t, e, n) => {
  !t && typeof console < "u" && console.warn(pt(e, n));
}, ne = (t, e, n) => {
  if (!t)
    throw new Error(pt(e, n));
});
const X = {};
// @__NO_SIDE_EFFECTS__
function Mt(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const ke = /* @__NO_SIDE_EFFECTS__ */ (t) => t, is = (t, e) => (n) => e(t(n)), Et = (...t) => t.reduce(is), an = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
};
class as {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return ss(this.subscriptions, e), () => rs(this.subscriptions, e);
  }
  notify(e, n, s) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let i = 0; i < r; i++) {
          const a = this.subscriptions[i];
          a && a(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const W = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, J = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function on(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Ft = /* @__PURE__ */ new Set();
function os(t, e, n) {
  t || Ft.has(e) || (console.warn(pt(e, n)), Ft.add(e));
}
const cn = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, cs = 1e-7, us = 12;
function ls(t, e, n, s, r) {
  let i, a, o = 0;
  do
    a = e + (n - e) / 2, i = cn(a, s, r) - t, i > 0 ? n = a : e = a;
  while (Math.abs(i) > cs && ++o < us);
  return a;
}
function Fe(t, e, n, s) {
  if (t === e && n === s)
    return ke;
  const r = (i) => ls(i, 0, 1, t, n);
  return (i) => i === 0 || i === 1 ? i : cn(r(i), e, s);
}
const un = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, ln = (t) => (e) => 1 - t(1 - e), dn = /* @__PURE__ */ Fe(0.33, 1.53, 0.69, 0.99), Rt = /* @__PURE__ */ ln(dn), fn = /* @__PURE__ */ un(Rt), hn = (t) => (t *= 2) < 1 ? 0.5 * Rt(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Nt = (t) => 1 - Math.sin(Math.acos(t)), ds = ln(Nt), pn = un(Nt), fs = /* @__PURE__ */ Fe(0.42, 0, 1, 1), hs = /* @__PURE__ */ Fe(0, 0, 0.58, 1), mn = /* @__PURE__ */ Fe(0.42, 0, 0.58, 1), ps = (t) => Array.isArray(t) && typeof t[0] != "number", yn = (t) => Array.isArray(t) && typeof t[0] == "number", Ut = {
  linear: ke,
  easeIn: fs,
  easeInOut: mn,
  easeOut: hs,
  circIn: Nt,
  circInOut: pn,
  circOut: ds,
  backIn: Rt,
  backInOut: fn,
  backOut: dn,
  anticipate: hn
}, ms = (t) => typeof t == "string", Wt = (t) => {
  if (yn(t)) {
    ne(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, s, r] = t;
    return Fe(e, n, s, r);
  } else if (ms(t))
    return ne(Ut[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Ut[t];
  return t;
}, We = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Kt = {
  value: null,
  addProjectionMetrics: null
};
function ys(t, e) {
  let n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, c = 0;
  function l(f) {
    a.has(f) && (u.schedule(f), t()), c++, f(o);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, y = !1, S = !1) => {
      const k = S && r ? n : s;
      return y && a.add(f), k.has(f) || k.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      s.delete(f), a.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (o = f, r) {
        i = !0;
        return;
      }
      r = !0, [n, s] = [s, n], n.forEach(l), e && Kt.value && Kt.value.frameloop[e].push(c), c = 0, n.clear(), r = !1, i && (i = !1, u.process(f));
    }
  };
  return u;
}
const gs = 40;
function vs(t, e) {
  let n = !1, s = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, a = We.reduce((R, Z) => (R[Z] = ys(i, e ? Z : void 0), R), {}), { setup: o, read: c, resolveKeyframes: l, preUpdate: u, update: f, preRender: y, render: S, postRender: E } = a, k = () => {
    const R = X.useManualTiming ? r.timestamp : performance.now();
    n = !1, X.useManualTiming || (r.delta = s ? 1e3 / 60 : Math.max(Math.min(R - r.timestamp, gs), 1)), r.timestamp = R, r.isProcessing = !0, o.process(r), c.process(r), l.process(r), u.process(r), f.process(r), y.process(r), S.process(r), E.process(r), r.isProcessing = !1, n && e && (s = !1, t(k));
  }, A = () => {
    n = !0, s = !0, r.isProcessing || t(k);
  };
  return { schedule: We.reduce((R, Z) => {
    const x = a[Z];
    return R[Z] = (N, I = !1, w = !1) => (n || A(), x.schedule(N, I, w)), R;
  }, {}), cancel: (R) => {
    for (let Z = 0; Z < We.length; Z++)
      a[We[Z]].cancel(R);
  }, state: r, steps: a };
}
const { schedule: fe, cancel: _s, state: qe, steps: wa } = /* @__PURE__ */ vs(typeof requestAnimationFrame < "u" ? requestAnimationFrame : ke, !0);
let Ke;
function bs() {
  Ke = void 0;
}
const L = {
  now: () => (Ke === void 0 && L.set(qe.isProcessing || X.useManualTiming ? qe.timestamp : performance.now()), Ke),
  set: (t) => {
    Ke = t, queueMicrotask(bs);
  }
}, xs = (t) => (e) => typeof e == "string" && e.startsWith(t), Ts = /* @__PURE__ */ xs("var(--"), ks = (t) => Ts(t) ? ws.test(t.split("/*")[0].trim()) : !1, ws = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, gn = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, vn = {
  ...gn,
  transform: (t) => de(0, 1, t)
}, Ce = (t) => Math.round(t * 1e5) / 1e5, _n = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Ss(t) {
  return t == null;
}
const As = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Zt = (t, e) => (n) => !!(typeof n == "string" && As.test(n) && n.startsWith(t) || e && !Ss(n) && Object.prototype.hasOwnProperty.call(n, e)), bn = (t, e, n) => (s) => {
  if (typeof s != "string")
    return s;
  const [r, i, a, o] = s.match(_n);
  return {
    [t]: parseFloat(r),
    [e]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: o !== void 0 ? parseFloat(o) : 1
  };
}, Cs = (t) => de(0, 255, t), ct = {
  ...gn,
  transform: (t) => Math.round(Cs(t))
}, oe = {
  test: /* @__PURE__ */ Zt("rgb", "red"),
  parse: /* @__PURE__ */ bn("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + ct.transform(t) + ", " + ct.transform(e) + ", " + ct.transform(n) + ", " + Ce(vn.transform(s)) + ")"
};
function Os(t) {
  let e = "", n = "", s = "", r = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), r = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), r = t.substring(4, 5), e += e, n += n, s += s, r += r), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const mt = {
  test: /* @__PURE__ */ Zt("#"),
  parse: Os,
  transform: oe.transform
}, Ms = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), qt = /* @__PURE__ */ Ms("%"), ye = {
  test: /* @__PURE__ */ Zt("hsl", "hue"),
  parse: /* @__PURE__ */ bn("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + qt.transform(Ce(e)) + ", " + qt.transform(Ce(n)) + ", " + Ce(vn.transform(s)) + ")"
}, Q = {
  test: (t) => oe.test(t) || mt.test(t) || ye.test(t),
  parse: (t) => oe.test(t) ? oe.parse(t) : ye.test(t) ? ye.parse(t) : mt.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? oe.transform(t) : ye.transform(t),
  getAnimatableNone: (t) => {
    const e = Q.parse(t);
    return e.alpha = 0, Q.transform(e);
  }
}, Es = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Rs(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(_n)) == null ? void 0 : e.length) || 0) + (((n = t.match(Es)) == null ? void 0 : n.length) || 0) > 0;
}
const xn = "number", Tn = "color", Ns = "var", Zs = "var(", Gt = "${}", Is = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ge(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let i = 0;
  const o = e.replace(Is, (c) => (Q.test(c) ? (s.color.push(i), r.push(Tn), n.push(Q.parse(c))) : c.startsWith(Zs) ? (s.var.push(i), r.push(Ns), n.push(c)) : (s.number.push(i), r.push(xn), n.push(parseFloat(c))), ++i, Gt)).split(Gt);
  return { values: n, split: o, indexes: s, types: r };
}
function kn(t) {
  return Ge(t).values;
}
function wn(t) {
  const { split: e, types: n } = Ge(t), s = e.length;
  return (r) => {
    let i = "";
    for (let a = 0; a < s; a++)
      if (i += e[a], r[a] !== void 0) {
        const o = n[a];
        o === xn ? i += Ce(r[a]) : o === Tn ? i += Q.transform(r[a]) : i += r[a];
      }
    return i;
  };
}
const Ds = (t) => typeof t == "number" ? 0 : Q.test(t) ? Q.getAnimatableNone(t) : t;
function Vs(t) {
  const e = kn(t);
  return wn(t)(e.map(Ds));
}
const Sn = {
  test: Rs,
  parse: kn,
  createTransformer: wn,
  getAnimatableNone: Vs
};
function ut(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function Ps({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let r = 0, i = 0, a = 0;
  if (!e)
    r = i = a = n;
  else {
    const o = n < 0.5 ? n * (1 + e) : n + e - n * e, c = 2 * n - o;
    r = ut(c, o, t + 1 / 3), i = ut(c, o, t), a = ut(c, o, t - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: s
  };
}
function Ye(t, e) {
  return (n) => n > 0 ? e : t;
}
const at = (t, e, n) => t + (e - t) * n, lt = (t, e, n) => {
  const s = t * t, r = n * (e * e - s) + s;
  return r < 0 ? 0 : Math.sqrt(r);
}, js = [mt, oe, ye], $s = (t) => js.find((e) => e.test(t));
function Yt(t) {
  const e = $s(t);
  if (Be(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === ye && (n = Ps(n)), n;
}
const Ht = (t, e) => {
  const n = Yt(t), s = Yt(e);
  if (!n || !s)
    return Ye(t, e);
  const r = { ...n };
  return (i) => (r.red = lt(n.red, s.red, i), r.green = lt(n.green, s.green, i), r.blue = lt(n.blue, s.blue, i), r.alpha = at(n.alpha, s.alpha, i), oe.transform(r));
}, yt = /* @__PURE__ */ new Set(["none", "hidden"]);
function Ls(t, e) {
  return yt.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function zs(t, e) {
  return (n) => at(t, e, n);
}
function It(t) {
  return typeof t == "number" ? zs : typeof t == "string" ? ks(t) ? Ye : Q.test(t) ? Ht : Us : Array.isArray(t) ? An : typeof t == "object" ? Q.test(t) ? Ht : Bs : Ye;
}
function An(t, e) {
  const n = [...t], s = n.length, r = t.map((i, a) => It(i)(i, e[a]));
  return (i) => {
    for (let a = 0; a < s; a++)
      n[a] = r[a](i);
    return n;
  };
}
function Bs(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const r in n)
    t[r] !== void 0 && e[r] !== void 0 && (s[r] = It(t[r])(t[r], e[r]));
  return (r) => {
    for (const i in s)
      n[i] = s[i](r);
    return n;
  };
}
function Fs(t, e) {
  const n = [], s = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < e.values.length; r++) {
    const i = e.types[r], a = t.indexes[i][s[i]], o = t.values[a] ?? 0;
    n[r] = o, s[i]++;
  }
  return n;
}
const Us = (t, e) => {
  const n = Sn.createTransformer(e), s = Ge(t), r = Ge(e);
  return s.indexes.var.length === r.indexes.var.length && s.indexes.color.length === r.indexes.color.length && s.indexes.number.length >= r.indexes.number.length ? yt.has(t) && !r.values.length || yt.has(e) && !s.values.length ? Ls(t, e) : Et(An(Fs(s, r), r.values), n) : (Be(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Ye(t, e));
};
function Cn(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? at(t, e, n) : It(t)(t, e);
}
const Ws = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => fe.update(e, n),
    stop: () => _s(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => qe.isProcessing ? qe.timestamp : L.now()
  };
}, On = (t, e, n = 10) => {
  let s = "";
  const r = Math.max(Math.round(e / n), 2);
  for (let i = 0; i < r; i++)
    s += Math.round(t(i / (r - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${s.substring(0, s.length - 2)})`;
}, He = 2e4;
function Dt(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < He; )
    e += n, s = t.next(e);
  return e >= He ? 1 / 0 : e;
}
function Ks(t, e = 100, n) {
  const s = n({ ...t, keyframes: [0, e] }), r = Math.min(Dt(s), He);
  return {
    type: "keyframes",
    ease: (i) => s.next(r * i).value / e,
    duration: /* @__PURE__ */ J(r)
  };
}
const qs = 5;
function Mn(t, e, n) {
  const s = Math.max(e - qs, 0);
  return on(n - t(s), e - s);
}
const O = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, dt = 1e-3;
function Gs({ duration: t = O.duration, bounce: e = O.bounce, velocity: n = O.velocity, mass: s = O.mass }) {
  let r, i;
  Be(t <= /* @__PURE__ */ W(O.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let a = 1 - e;
  a = de(O.minDamping, O.maxDamping, a), t = de(O.minDuration, O.maxDuration, /* @__PURE__ */ J(t)), a < 1 ? (r = (l) => {
    const u = l * a, f = u * t, y = u - n, S = gt(l, a), E = Math.exp(-f);
    return dt - y / S * E;
  }, i = (l) => {
    const f = l * a * t, y = f * n + n, S = Math.pow(a, 2) * Math.pow(l, 2) * t, E = Math.exp(-f), k = gt(Math.pow(l, 2), a);
    return (-r(l) + dt > 0 ? -1 : 1) * ((y - S) * E) / k;
  }) : (r = (l) => {
    const u = Math.exp(-l * t), f = (l - n) * t + 1;
    return -dt + u * f;
  }, i = (l) => {
    const u = Math.exp(-l * t), f = (n - l) * (t * t);
    return u * f;
  });
  const o = 5 / t, c = Hs(r, i, o);
  if (t = /* @__PURE__ */ W(t), isNaN(c))
    return {
      stiffness: O.stiffness,
      damping: O.damping,
      duration: t
    };
  {
    const l = Math.pow(c, 2) * s;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(s * l),
      duration: t
    };
  }
}
const Ys = 12;
function Hs(t, e, n) {
  let s = n;
  for (let r = 1; r < Ys; r++)
    s = s - t(s) / e(s);
  return s;
}
function gt(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Js = ["duration", "bounce"], Xs = ["stiffness", "damping", "mass"];
function Jt(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Qs(t) {
  let e = {
    velocity: O.velocity,
    stiffness: O.stiffness,
    damping: O.damping,
    mass: O.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Jt(t, Xs) && Jt(t, Js))
    if (t.visualDuration) {
      const n = t.visualDuration, s = 2 * Math.PI / (n * 1.2), r = s * s, i = 2 * de(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(r);
      e = {
        ...e,
        mass: O.mass,
        stiffness: r,
        damping: i
      };
    } else {
      const n = Gs(t);
      e = {
        ...e,
        ...n,
        mass: O.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Je(t = O.visualDuration, e = O.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: s, restDelta: r } = n;
  const i = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], o = { done: !1, value: i }, { stiffness: c, damping: l, mass: u, duration: f, velocity: y, isResolvedFromDuration: S } = Qs({
    ...n,
    velocity: -/* @__PURE__ */ J(n.velocity || 0)
  }), E = y || 0, k = l / (2 * Math.sqrt(c * u)), A = a - i, C = /* @__PURE__ */ J(Math.sqrt(c / u)), j = Math.abs(A) < 5;
  s || (s = j ? O.restSpeed.granular : O.restSpeed.default), r || (r = j ? O.restDelta.granular : O.restDelta.default);
  let R;
  if (k < 1) {
    const x = gt(C, k);
    R = (N) => {
      const I = Math.exp(-k * C * N);
      return a - I * ((E + k * C * A) / x * Math.sin(x * N) + A * Math.cos(x * N));
    };
  } else if (k === 1)
    R = (x) => a - Math.exp(-C * x) * (A + (E + C * A) * x);
  else {
    const x = C * Math.sqrt(k * k - 1);
    R = (N) => {
      const I = Math.exp(-k * C * N), w = Math.min(x * N, 300);
      return a - I * ((E + k * C * A) * Math.sinh(w) + x * A * Math.cosh(w)) / x;
    };
  }
  const Z = {
    calculatedDuration: S && f || null,
    next: (x) => {
      const N = R(x);
      if (S)
        o.done = x >= f;
      else {
        let I = x === 0 ? E : 0;
        k < 1 && (I = x === 0 ? /* @__PURE__ */ W(E) : Mn(R, x, N));
        const w = Math.abs(I) <= s, $ = Math.abs(a - N) <= r;
        o.done = w && $;
      }
      return o.value = o.done ? a : N, o;
    },
    toString: () => {
      const x = Math.min(Dt(Z), He), N = On((I) => Z.next(x * I).value, x, 30);
      return x + "ms " + N;
    },
    toTransition: () => {
    }
  };
  return Z;
}
Je.applyToOptions = (t) => {
  const e = Ks(t, 100, Je);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ W(e.duration), t.type = "keyframes", t;
};
function vt({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: a, min: o, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const f = t[0], y = {
    done: !1,
    value: f
  }, S = (w) => o !== void 0 && w < o || c !== void 0 && w > c, E = (w) => o === void 0 ? c : c === void 0 || Math.abs(o - w) < Math.abs(c - w) ? o : c;
  let k = n * e;
  const A = f + k, C = a === void 0 ? A : a(A);
  C !== A && (k = C - f);
  const j = (w) => -k * Math.exp(-w / s), R = (w) => C + j(w), Z = (w) => {
    const $ = j(w), Y = R(w);
    y.done = Math.abs($) <= l, y.value = y.done ? C : Y;
  };
  let x, N;
  const I = (w) => {
    S(y.value) && (x = w, N = Je({
      keyframes: [y.value, E(y.value)],
      velocity: Mn(R, w, y.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: i,
      restDelta: l,
      restSpeed: u
    }));
  };
  return I(0), {
    calculatedDuration: null,
    next: (w) => {
      let $ = !1;
      return !N && x === void 0 && ($ = !0, Z(w), I(w)), x !== void 0 && w >= x ? N.next(w - x) : (!$ && Z(w), y);
    }
  };
}
function er(t, e, n) {
  const s = [], r = n || X.mix || Cn, i = t.length - 1;
  for (let a = 0; a < i; a++) {
    let o = r(t[a], t[a + 1]);
    if (e) {
      const c = Array.isArray(e) ? e[a] || ke : e;
      o = Et(c, o);
    }
    s.push(o);
  }
  return s;
}
function tr(t, e, { clamp: n = !0, ease: s, mixer: r } = {}) {
  const i = t.length;
  if (ne(i === e.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => e[0];
  if (i === 2 && e[0] === e[1])
    return () => e[1];
  const a = t[0] === t[1];
  t[0] > t[i - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = er(e, s, r), c = o.length, l = (u) => {
    if (a && u < t[0])
      return e[0];
    let f = 0;
    if (c > 1)
      for (; f < t.length - 2 && !(u < t[f + 1]); f++)
        ;
    const y = /* @__PURE__ */ an(t[f], t[f + 1], u);
    return o[f](y);
  };
  return n ? (u) => l(de(t[0], t[i - 1], u)) : l;
}
function nr(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const r = /* @__PURE__ */ an(0, e, s);
    t.push(at(n, 1, r));
  }
}
function sr(t) {
  const e = [0];
  return nr(e, t.length - 1), e;
}
function rr(t, e) {
  return t.map((n) => n * e);
}
function ir(t, e) {
  return t.map(() => e || mn).splice(0, t.length - 1);
}
function ge({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const r = ps(s) ? s.map(Wt) : Wt(s), i = {
    done: !1,
    value: e[0]
  }, a = rr(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : sr(e),
    t
  ), o = tr(a, e, {
    ease: Array.isArray(r) ? r : ir(e, r)
  });
  return {
    calculatedDuration: t,
    next: (c) => (i.value = o(c), i.done = c >= t, i)
  };
}
const ar = (t) => t !== null;
function Vt(t, { repeat: e, repeatType: n = "loop" }, s, r = 1) {
  const i = t.filter(ar), o = r < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !o || s === void 0 ? i[o] : s;
}
const or = {
  decay: vt,
  inertia: vt,
  tween: ge,
  keyframes: ge,
  spring: Je
};
function En(t) {
  typeof t.type == "string" && (t.type = or[t.type]);
}
class Pt {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const cr = (t) => t / 100;
class jt extends Pt {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var s, r;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== L.now() && this.tick(L.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (r = (s = this.options).onStop) == null || r.call(s));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    En(e);
    const { type: n = ge, repeat: s = 0, repeatDelay: r = 0, repeatType: i, velocity: a = 0 } = e;
    let { keyframes: o } = e;
    const c = n || ge;
    process.env.NODE_ENV !== "production" && c !== ge && ne(o.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${o}`, "spring-two-frames"), c !== ge && typeof o[0] != "number" && (this.mixKeyframes = Et(cr, Cn(o[0], o[1])), o = [0, 100]);
    const l = c({ ...e, keyframes: o });
    i === "mirror" && (this.mirroredGenerator = c({
      ...e,
      keyframes: [...o].reverse(),
      velocity: -a
    })), l.calculatedDuration === null && (l.calculatedDuration = Dt(l));
    const { calculatedDuration: u } = l;
    this.calculatedDuration = u, this.resolvedDuration = u + r, this.totalDuration = this.resolvedDuration * (s + 1) - r, this.generator = l;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: s, totalDuration: r, mixKeyframes: i, mirroredGenerator: a, resolvedDuration: o, calculatedDuration: c } = this;
    if (this.startTime === null)
      return s.next(0);
    const { delay: l = 0, keyframes: u, repeat: f, repeatType: y, repeatDelay: S, type: E, onUpdate: k, finalKeyframe: A } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - r / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const C = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1), j = this.playbackSpeed >= 0 ? C < 0 : C > r;
    this.currentTime = Math.max(C, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
    let R = this.currentTime, Z = s;
    if (f) {
      const w = Math.min(this.currentTime, r) / o;
      let $ = Math.floor(w), Y = w % 1;
      !Y && w >= 1 && (Y = 1), Y === 1 && $--, $ = Math.min($, f + 1), !!($ % 2) && (y === "reverse" ? (Y = 1 - Y, S && (Y -= S / o)) : y === "mirror" && (Z = a)), R = de(0, 1, Y) * o;
    }
    const x = j ? { done: !1, value: u[0] } : Z.next(R);
    i && (x.value = i(x.value));
    let { done: N } = x;
    !j && c !== null && (N = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
    const I = this.holdTime === null && (this.state === "finished" || this.state === "running" && N);
    return I && E !== vt && (x.value = Vt(u, this.options, A, this.speed)), k && k(x.value), I && this.finish(), x;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ J(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ J(this.currentTime);
  }
  set time(e) {
    var n;
    e = /* @__PURE__ */ W(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(L.now());
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ J(this.currentTime));
  }
  play() {
    var r, i;
    if (this.isStopped)
      return;
    const { driver: e = Ws, startTime: n } = this.options;
    this.driver || (this.driver = e((a) => this.tick(a))), (i = (r = this.options).onPlay) == null || i.call(r);
    const s = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = s) : this.holdTime !== null ? this.startTime = s - this.holdTime : this.startTime || (this.startTime = n ?? s), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(L.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (e = this.options).onComplete) == null || n.call(e);
  }
  cancel() {
    var e, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (e = this.options).onCancel) == null || n.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), e.observe(this);
  }
}
function ur(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const $t = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], lr = /* @__PURE__ */ (() => new Set($t))(), dr = /* @__PURE__ */ new Set(["x", "y", "z"]), fr = $t.filter((t) => !dr.has(t));
function hr(t) {
  const e = [];
  return fr.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const ce = /* @__PURE__ */ new Set();
let _t = !1, bt = !1, xt = !1;
function Rn() {
  if (bt) {
    const t = Array.from(ce).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const r = hr(s);
      r.length && (n.set(s, r), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const r = n.get(s);
      r && r.forEach(([i, a]) => {
        var o;
        (o = s.getValue(i)) == null || o.set(a);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  bt = !1, _t = !1, ce.forEach((t) => t.complete(xt)), ce.clear();
}
function Nn() {
  ce.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (bt = !0);
  });
}
function pr() {
  xt = !0, Nn(), Rn(), xt = !1;
}
class mr {
  constructor(e, n, s, r, i, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = r, this.element = i, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (ce.add(this), _t || (_t = !0, fe.read(Nn), fe.resolveKeyframes(Rn))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: r } = this;
    if (e[0] === null) {
      const i = r == null ? void 0 : r.get(), a = e[e.length - 1];
      if (i !== void 0)
        e[0] = i;
      else if (s && n) {
        const o = s.readValue(n, a);
        o != null && (e[0] = o);
      }
      e[0] === void 0 && (e[0] = a), r && i === void 0 && r.set(e[0]);
    }
    ur(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), ce.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (ce.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const yr = (t) => t.startsWith("--");
function gr(t, e, n) {
  yr(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const vr = /* @__PURE__ */ Mt(() => window.ScrollTimeline !== void 0), _r = {};
function br(t, e) {
  const n = /* @__PURE__ */ Mt(t);
  return () => _r[e] ?? n();
}
const Zn = /* @__PURE__ */ br(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), we = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, Xt = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ we([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ we([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ we([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ we([0.33, 1.53, 0.69, 0.99])
};
function In(t, e) {
  if (t)
    return typeof t == "function" ? Zn() ? On(t, e) : "ease-out" : yn(t) ? we(t) : Array.isArray(t) ? t.map((n) => In(n, e) || Xt.easeOut) : Xt[t];
}
function xr(t, e, n, { delay: s = 0, duration: r = 300, repeat: i = 0, repeatType: a = "loop", ease: o = "easeOut", times: c } = {}, l = void 0) {
  const u = {
    [e]: n
  };
  c && (u.offset = c);
  const f = In(o, r);
  Array.isArray(f) && (u.easing = f);
  const y = {
    delay: s,
    duration: r,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return l && (y.pseudoElement = l), t.animate(u, y);
}
function Dn(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function Tr({ type: t, ...e }) {
  return Dn(t) && Zn() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class kr extends Pt {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e)
      return;
    const { element: n, name: s, keyframes: r, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: o, onComplete: c } = e;
    this.isPseudoElement = !!i, this.allowFlatten = a, this.options = e, ne(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const l = Tr(e);
    this.animation = xr(n, s, r, l, i), l.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = Vt(r, this.options, o, this.speed);
        this.updateMotionValue ? this.updateMotionValue(u) : gr(n, s, u), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, n;
    (n = (e = this.animation).finish) == null || n.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, n;
    this.isPseudoElement || (n = (e = this.animation).commitStyles) == null || n.call(e);
  }
  get duration() {
    var n, s;
    const e = ((s = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : s.call(n).duration) || 0;
    return /* @__PURE__ */ J(Number(e));
  }
  get time() {
    return /* @__PURE__ */ J(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ W(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: n }) {
    var s;
    return this.allowFlatten && ((s = this.animation.effect) == null || s.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && vr() ? (this.animation.timeline = e, ke) : n(this);
  }
}
const Vn = {
  anticipate: hn,
  backInOut: fn,
  circInOut: pn
};
function wr(t) {
  return t in Vn;
}
function Sr(t) {
  typeof t.ease == "string" && wr(t.ease) && (t.ease = Vn[t.ease]);
}
const Qt = 10;
class Ar extends kr {
  constructor(e) {
    Sr(e), En(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: s, onComplete: r, element: i, ...a } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const o = new jt({
      ...a,
      autoplay: !1
    }), c = /* @__PURE__ */ W(this.finishedTime ?? this.time);
    n.setWithVelocity(o.sample(c - Qt).value, o.sample(c).value, Qt), o.stop();
  }
}
const en = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Sn.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function Cr(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function Or(t, e, n, s) {
  const r = t[0];
  if (r === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const i = t[t.length - 1], a = en(r, e), o = en(i, e);
  return Be(a === o, `You are trying to animate ${e} from "${r}" to "${i}". "${a ? i : r}" is not an animatable value.`, "value-not-animatable"), !a || !o ? !1 : Cr(t) || (n === "spring" || Dn(n)) && s;
}
function Tt(t) {
  t.duration = 0, t.type;
}
const Mr = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), Er = /* @__PURE__ */ Mt(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Rr(t) {
  var u;
  const { motionValue: e, name: n, repeatDelay: s, repeatType: r, damping: i, type: a } = t;
  if (!(((u = e == null ? void 0 : e.owner) == null ? void 0 : u.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: l } = e.owner.getProps();
  return Er() && n && Mr.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !s && r !== "mirror" && i !== 0 && a !== "inertia";
}
const Nr = 40;
class Zr extends Pt {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a = "loop", keyframes: o, name: c, motionValue: l, element: u, ...f }) {
    var E;
    super(), this.stop = () => {
      var k, A;
      this._animation && (this._animation.stop(), (k = this.stopTimeline) == null || k.call(this)), (A = this.keyframeResolver) == null || A.cancel();
    }, this.createdAt = L.now();
    const y = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: r,
      repeatDelay: i,
      repeatType: a,
      name: c,
      motionValue: l,
      element: u,
      ...f
    }, S = (u == null ? void 0 : u.KeyframeResolver) || mr;
    this.keyframeResolver = new S(o, (k, A, C) => this.onKeyframesResolved(k, A, y, !C), c, l, u), (E = this.keyframeResolver) == null || E.scheduleResolve();
  }
  onKeyframesResolved(e, n, s, r) {
    this.keyframeResolver = void 0;
    const { name: i, type: a, velocity: o, delay: c, isHandoff: l, onUpdate: u } = s;
    this.resolvedAt = L.now(), Or(e, i, a, o) || ((X.instantAnimations || !c) && (u == null || u(Vt(e, s, n))), e[0] = e[e.length - 1], Tt(s), s.repeat = 0);
    const y = {
      startTime: r ? this.resolvedAt ? this.resolvedAt - this.createdAt > Nr ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...s,
      keyframes: e
    }, S = !l && Rr(y) ? new Ar({
      ...y,
      element: y.motionValue.owner.current
    }) : new jt(y);
    S.finished.then(() => this.notifyFinished()).catch(ke), this.pendingTimeline && (this.stopTimeline = S.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = S;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), pr()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
function Pn(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const Ir = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...$t
]), tn = 30, Dr = (t) => !isNaN(parseFloat(t));
class Vr {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s) => {
      var i;
      const r = L.now();
      if (this.updatedAt !== r && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const a of this.dependents)
          a.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = L.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Dr(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && os(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new as());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), fe.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = L.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > tn)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, tn);
    return on(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, n;
    (e = this.dependents) == null || e.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Pr(t, e) {
  return new Vr(t, e);
}
const jr = (t) => !!(t && t.getVelocity);
function nn(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function $r(t, e, n, s) {
  if (typeof e == "function") {
    const [r, i] = nn(s);
    e = e(n !== void 0 ? n : t.custom, r, i);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [r, i] = nn(s);
    e = e(n !== void 0 ? n : t.custom, r, i);
  }
  return e;
}
const Lr = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), zr = "framerAppearId", Br = "data-" + Lr(zr);
function Lt(t, e, n) {
  const s = t.getProps();
  return $r(s, e, n !== void 0 ? n : s.custom, t);
}
const Fr = (t) => Array.isArray(t);
function Ur(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, Pr(n));
}
function Wr(t) {
  return Fr(t) ? t[t.length - 1] || 0 : t;
}
function zt(t, e) {
  const n = Lt(t, e);
  let { transitionEnd: s = {}, transition: r = {}, ...i } = n || {};
  i = { ...i, ...s };
  for (const a in i) {
    const o = Wr(i[a]);
    Ur(t, a, o);
  }
}
function Kr(t) {
  return !!(jr(t) && t.add);
}
function qr(t, e) {
  const n = t.getValue("willChange");
  if (Kr(n))
    return n.add(e);
  if (!n && X.WillChange) {
    const s = new X.WillChange("auto");
    t.addValue("willChange", s), s.add(e);
  }
}
function Gr(t) {
  return t.props[Br];
}
const Yr = (t) => t !== null;
function Hr(t, { repeat: e, repeatType: n = "loop" }, s) {
  const r = t.filter(Yr), i = e && n !== "loop" && e % 2 === 1 ? 0 : r.length - 1;
  return !i || s === void 0 ? r[i] : s;
}
const Jr = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Xr = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Qr = {
  type: "keyframes",
  duration: 0.8
}, ei = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, ti = (t, { keyframes: e }) => e.length > 2 ? Qr : lr.has(t) ? t.startsWith("scale") ? Xr(e[1]) : Jr : ei;
function ni({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: r, repeat: i, repeatType: a, repeatDelay: o, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
const si = (t, e, n, s = {}, r, i) => (a) => {
  const o = Pn(s, t) || {}, c = o.delay || s.delay || 0;
  let { elapsed: l = 0 } = s;
  l = l - /* @__PURE__ */ W(c);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...o,
    delay: -l,
    onUpdate: (y) => {
      e.set(y), o.onUpdate && o.onUpdate(y);
    },
    onComplete: () => {
      a(), o.onComplete && o.onComplete();
    },
    name: t,
    motionValue: e,
    element: i ? void 0 : r
  };
  ni(o) || Object.assign(u, ti(t, u)), u.duration && (u.duration = /* @__PURE__ */ W(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ W(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Tt(u), u.delay === 0 && (f = !0)), (X.instantAnimations || X.skipAnimations) && (f = !0, Tt(u), u.delay = 0), u.allowFlatten = !o.type && !o.ease, f && !i && e.get() !== void 0) {
    const y = Hr(u.keyframes, o);
    if (y !== void 0) {
      fe.update(() => {
        u.onUpdate(y), u.onComplete();
      });
      return;
    }
  }
  return o.isSync ? new jt(u) : new Zr(u);
};
function ri({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function jn(t, e, { delay: n = 0, transitionOverride: s, type: r } = {}) {
  let { transition: i = t.getDefaultTransition(), transitionEnd: a, ...o } = e;
  s && (i = s);
  const c = [], l = r && t.animationState && t.animationState.getState()[r];
  for (const u in o) {
    const f = t.getValue(u, t.latestValues[u] ?? null), y = o[u];
    if (y === void 0 || l && ri(l, u))
      continue;
    const S = {
      delay: n,
      ...Pn(i || {}, u)
    }, E = f.get();
    if (E !== void 0 && !f.isAnimating && !Array.isArray(y) && y === E && !S.velocity)
      continue;
    let k = !1;
    if (window.MotionHandoffAnimation) {
      const C = Gr(t);
      if (C) {
        const j = window.MotionHandoffAnimation(C, u, fe);
        j !== null && (S.startTime = j, k = !0);
      }
    }
    qr(t, u), f.start(si(u, f, y, t.shouldReduceMotion && Ir.has(u) ? { type: !1 } : S, t, k));
    const A = f.animation;
    A && c.push(A);
  }
  return a && Promise.all(c).then(() => {
    fe.update(() => {
      a && zt(t, a);
    });
  }), c;
}
function ii(t, e, n, s = 0, r = 1) {
  const i = Array.from(t).sort((l, u) => l.sortNodePosition(u)).indexOf(e), a = t.size, o = (a - 1) * s;
  return typeof n == "function" ? n(i, a) : r === 1 ? i * s : o - i * s;
}
function kt(t, e, n = {}) {
  var c;
  const s = Lt(t, e, n.type === "exit" ? (c = t.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: r = t.getDefaultTransition() || {} } = s || {};
  n.transitionOverride && (r = n.transitionOverride);
  const i = s ? () => Promise.all(jn(t, s, n)) : () => Promise.resolve(), a = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: y } = r;
    return ai(t, e, l, u, f, y, n);
  } : () => Promise.resolve(), { when: o } = r;
  if (o) {
    const [l, u] = o === "beforeChildren" ? [i, a] : [a, i];
    return l().then(() => u());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function ai(t, e, n = 0, s = 0, r = 0, i = 1, a) {
  const o = [];
  for (const c of t.variantChildren)
    c.notify("AnimationStart", e), o.push(kt(c, e, {
      ...a,
      delay: n + (typeof s == "function" ? 0 : s) + ii(t.variantChildren, c, s, r, i)
    }).then(() => c.notify("AnimationComplete", e)));
  return Promise.all(o);
}
function oi(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const r = e.map((i) => kt(t, i, n));
    s = Promise.all(r);
  } else if (typeof e == "string")
    s = kt(t, e, n);
  else {
    const r = typeof e == "function" ? Lt(t, e, n.custom) : e;
    s = Promise.all(jn(t, r, n));
  }
  return s.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function ci(t) {
  t.values.forEach((e) => e.stop());
}
function wt(t, e) {
  [...e].reverse().forEach((s) => {
    const r = t.getVariant(s);
    r && zt(t, r), t.variantChildren && t.variantChildren.forEach((i) => {
      wt(i, e);
    });
  });
}
function ui(t, e) {
  if (Array.isArray(e))
    return wt(t, e);
  if (typeof e == "string")
    return wt(t, [e]);
  zt(t, e);
}
function li() {
  let t = !1;
  const e = /* @__PURE__ */ new Set(), n = {
    subscribe(s) {
      return e.add(s), () => void e.delete(s);
    },
    start(s, r) {
      ne(t, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
      const i = [];
      return e.forEach((a) => {
        i.push(oi(a, s, {
          transitionOverride: r
        }));
      }), Promise.all(i);
    },
    set(s) {
      return ne(t, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook."), e.forEach((r) => {
        ui(r, s);
      });
    },
    stop() {
      e.forEach((s) => {
        ci(s);
      });
    },
    mount() {
      return t = !0, () => {
        t = !1, n.stop();
      };
    }
  };
  return n;
}
function di() {
  const t = es(li);
  return ns(t.mount, []), t;
}
const fi = di, $n = "(prefers-reduced-motion: no-preference)", hi = typeof window > "u", pi = () => hi ? !0 : !window.matchMedia($n).matches, mi = () => {
  const [t, e] = it(pi);
  return le(() => {
    const n = window.matchMedia($n), s = (r) => {
      e(!r.matches);
    };
    return n.addEventListener && n.addEventListener("change", s), () => {
      n.removeEventListener && n.removeEventListener("change", s);
    };
  }, []), t;
}, Sa = ({
  x: t = 0,
  y: e = 0,
  rotation: n = 0,
  scale: s = 1,
  timing: r = 150,
  springConfig: i = {
    stiffness: 300,
    damping: 10,
    mass: 1
  }
}) => {
  const a = mi(), [o, c] = it(!1), l = fi();
  le(() => {
    o ? l.start({
      display: "inline-block",
      transform: `translate(${t}px, ${e}px) rotate(${n}deg) scale(${s})`,
      transition: { type: "spring", ...i }
    }) : l.start({
      display: "inline-block",
      transform: "translate(0px, 0px) rotate(0deg) scale(1)",
      transition: { type: "spring", ...i }
    });
  }, [o]), le(() => {
    if (!o)
      return;
    const y = window.setTimeout(() => {
      c(!1);
    }, r);
    return () => {
      window.clearTimeout(y);
    };
  }, [o]);
  const u = Xn(() => {
    c(!0);
  }, []);
  return [a ? {} : l, u];
};
var T;
(function(t) {
  t.assertEqual = (r) => r;
  function e(r) {
  }
  t.assertIs = e;
  function n(r) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (r) => {
    const i = {};
    for (const a of r)
      i[a] = a;
    return i;
  }, t.getValidEnumValues = (r) => {
    const i = t.objectKeys(r).filter((o) => typeof r[r[o]] != "number"), a = {};
    for (const o of i)
      a[o] = r[o];
    return t.objectValues(a);
  }, t.objectValues = (r) => t.objectKeys(r).map(function(i) {
    return r[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const a in r)
      Object.prototype.hasOwnProperty.call(r, a) && i.push(a);
    return i;
  }, t.find = (r, i) => {
    for (const a of r)
      if (i(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function s(r, i = " | ") {
    return r.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  t.joinValues = s, t.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(T || (T = {}));
var St;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(St || (St = {}));
const p = T.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), te = (t) => {
  switch (typeof t) {
    case "undefined":
      return p.undefined;
    case "string":
      return p.string;
    case "number":
      return isNaN(t) ? p.nan : p.number;
    case "boolean":
      return p.boolean;
    case "function":
      return p.function;
    case "bigint":
      return p.bigint;
    case "symbol":
      return p.symbol;
    case "object":
      return Array.isArray(t) ? p.array : t === null ? p.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? p.promise : typeof Map < "u" && t instanceof Map ? p.map : typeof Set < "u" && t instanceof Set ? p.set : typeof Date < "u" && t instanceof Date ? p.date : p.object;
    default:
      return p.unknown;
  }
}, d = T.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), yi = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class P extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, s = { _errors: [] }, r = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(r);
        else if (a.code === "invalid_return_type")
          r(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          r(a.argumentsError);
        else if (a.path.length === 0)
          s._errors.push(n(a));
        else {
          let o = s, c = 0;
          for (; c < a.path.length; ) {
            const l = a.path[c];
            c === a.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(n(a))) : o[l] = o[l] || { _errors: [] }, o = o[l], c++;
          }
        }
    };
    return r(this), s;
  }
  static assert(e) {
    if (!(e instanceof P))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, T.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, s = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(e(r))) : s.push(e(r));
    return { formErrors: s, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
P.create = (t) => new P(t);
const be = (t, e) => {
  let n;
  switch (t.code) {
    case d.invalid_type:
      t.received === p.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case d.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, T.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${T.joinValues(t.keys, ", ")}`;
      break;
    case d.invalid_union:
      n = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${T.joinValues(t.options)}`;
      break;
    case d.invalid_enum_value:
      n = `Invalid enum value. Expected ${T.joinValues(t.options)}, received '${t.received}'`;
      break;
    case d.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      n = "Invalid function return type";
      break;
    case d.invalid_date:
      n = "Invalid date";
      break;
    case d.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : T.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case d.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case d.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case d.custom:
      n = "Invalid input";
      break;
    case d.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case d.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, T.assertNever(t);
  }
  return { message: n };
};
let Ln = be;
function gi(t) {
  Ln = t;
}
function Xe() {
  return Ln;
}
const Qe = (t) => {
  const { data: e, path: n, errorMaps: s, issueData: r } = t, i = [...n, ...r.path || []], a = {
    ...r,
    path: i
  };
  if (r.message !== void 0)
    return {
      ...r,
      path: i,
      message: r.message
    };
  let o = "";
  const c = s.filter((l) => !!l).slice().reverse();
  for (const l of c)
    o = l(a, { data: e, defaultError: o }).message;
  return {
    ...r,
    path: i,
    message: o
  };
}, vi = [];
function h(t, e) {
  const n = Xe(), s = Qe({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      n,
      n === be ? void 0 : be
      // then global default map
    ].filter((r) => !!r)
  });
  t.common.issues.push(s);
}
class D {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const s = [];
    for (const r of n) {
      if (r.status === "aborted")
        return v;
      r.status === "dirty" && e.dirty(), s.push(r.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, n) {
    const s = [];
    for (const r of n) {
      const i = await r.key, a = await r.value;
      s.push({
        key: i,
        value: a
      });
    }
    return D.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, n) {
    const s = {};
    for (const r of n) {
      const { key: i, value: a } = r;
      if (i.status === "aborted" || a.status === "aborted")
        return v;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || r.alwaysSet) && (s[i.value] = a.value);
    }
    return { status: e.value, value: s };
  }
}
const v = Object.freeze({
  status: "aborted"
}), ve = (t) => ({ status: "dirty", value: t }), V = (t) => ({ status: "valid", value: t }), At = (t) => t.status === "aborted", Ct = (t) => t.status === "dirty", Oe = (t) => t.status === "valid", Me = (t) => typeof Promise < "u" && t instanceof Promise;
function et(t, e, n, s) {
  if (n === "a" && !s)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !s : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? s : n === "a" ? s.call(t) : s ? s.value : e.get(t);
}
function zn(t, e, n, s, r) {
  if (s === "m")
    throw new TypeError("Private method is not writable");
  if (s === "a" && !r)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return s === "a" ? r.call(t, n) : r ? r.value = n : e.set(t, n), n;
}
var m;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(m || (m = {}));
var Se, Ae;
class q {
  constructor(e, n, s, r) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = s, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const sn = (t, e) => {
  if (Oe(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new P(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function _(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: s, description: r } = t;
  if (e && (n || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: r } : { errorMap: (a, o) => {
    var c, l;
    const { message: u } = t;
    return a.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: (c = u ?? s) !== null && c !== void 0 ? c : o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: (l = u ?? n) !== null && l !== void 0 ? l : o.defaultError };
  }, description: r };
}
class b {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return te(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: te(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new D(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: te(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Me(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const s = this.safeParse(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, n) {
    var s;
    const r = {
      common: {
        issues: [],
        async: (s = n == null ? void 0 : n.async) !== null && s !== void 0 ? s : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: te(e)
    }, i = this._parseSync({ data: e, path: r.path, parent: r });
    return sn(r, i);
  }
  async parseAsync(e, n) {
    const s = await this.safeParseAsync(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, n) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: te(e)
    }, r = this._parse({ data: e, path: s.path, parent: s }), i = await (Me(r) ? r : Promise.resolve(r));
    return sn(s, i);
  }
  refine(e, n) {
    const s = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const a = e(r), o = () => i.addIssue({
        code: d.custom,
        ...s(r)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((s, r) => e(s) ? !0 : (r.addIssue(typeof n == "function" ? n(s, r) : n), !1));
  }
  _refinement(e) {
    return new F({
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return K.create(this, this._def);
  }
  nullable() {
    return ae.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return B.create(this, this._def);
  }
  promise() {
    return Te.create(this, this._def);
  }
  or(e) {
    return Ze.create([this, e], this._def);
  }
  and(e) {
    return Ie.create(this, e, this._def);
  }
  transform(e) {
    return new F({
      ..._(this._def),
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new $e({
      ..._(this._def),
      innerType: this,
      defaultValue: n,
      typeName: g.ZodDefault
    });
  }
  brand() {
    return new Bt({
      typeName: g.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Le({
      ..._(this._def),
      innerType: this,
      catchValue: n,
      typeName: g.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Ue.create(this, e);
  }
  readonly() {
    return ze.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const _i = /^c[^\s-]{8,}$/i, bi = /^[0-9a-z]+$/, xi = /^[0-9A-HJKMNP-TV-Z]{26}$/, Ti = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ki = /^[a-z0-9_-]{21}$/i, wi = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Si = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ai = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ft;
const Ci = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Oi = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Mi = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Bn = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ei = new RegExp(`^${Bn}$`);
function Fn(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Ri(t) {
  return new RegExp(`^${Fn(t)}$`);
}
function Un(t) {
  let e = `${Bn}T${Fn(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Ni(t, e) {
  return !!((e === "v4" || !e) && Ci.test(t) || (e === "v6" || !e) && Oi.test(t));
}
class z extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== p.string) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: p.string,
        received: i.parsedType
      }), v;
    }
    const s = new D();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), s.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), s.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (r = this._getOrReturnCtx(e, r), a ? h(r, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && h(r, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), s.dirty());
      } else if (i.kind === "email")
        Si.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "email",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "emoji")
        ft || (ft = new RegExp(Ai, "u")), ft.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "emoji",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "uuid")
        Ti.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "uuid",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "nanoid")
        ki.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "nanoid",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "cuid")
        _i.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "cuid2")
        bi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid2",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "ulid")
        xi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "ulid",
          code: d.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          r = this._getOrReturnCtx(e, r), h(r, {
            validation: "url",
            code: d.invalid_string,
            message: i.message
          }), s.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "regex",
          code: d.invalid_string,
          message: i.message
        }), s.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), s.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), s.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), s.dirty()) : i.kind === "datetime" ? Un(i).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "datetime",
          message: i.message
        }), s.dirty()) : i.kind === "date" ? Ei.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "date",
          message: i.message
        }), s.dirty()) : i.kind === "time" ? Ri(i).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "time",
          message: i.message
        }), s.dirty()) : i.kind === "duration" ? wi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "duration",
          code: d.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "ip" ? Ni(e.data, i.version) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "ip",
          code: d.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "base64" ? Mi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "base64",
          code: d.invalid_string,
          message: i.message
        }), s.dirty()) : T.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _regex(e, n, s) {
    return this.refinement((r) => e.test(r), {
      validation: n,
      code: d.invalid_string,
      ...m.errToObj(s)
    });
  }
  _addCheck(e) {
    return new z({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...m.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...m.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...m.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...m.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...m.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...m.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...m.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...m.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...m.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...m.errToObj(e) });
  }
  datetime(e) {
    var n, s;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      local: (s = e == null ? void 0 : e.local) !== null && s !== void 0 ? s : !1,
      ...m.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...m.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...m.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...m.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...m.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...m.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...m.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...m.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...m.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...m.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, m.errToObj(e));
  }
  trim() {
    return new z({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new z({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new z({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
z.create = (t) => {
  var e;
  return new z({
    checks: [],
    typeName: g.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ..._(t)
  });
};
function Zi(t, e) {
  const n = (t.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, r = n > s ? n : s, i = parseInt(t.toFixed(r).replace(".", "")), a = parseInt(e.toFixed(r).replace(".", ""));
  return i % a / Math.pow(10, r);
}
class se extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== p.number) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: p.number,
        received: i.parsedType
      }), v;
    }
    let s;
    const r = new D();
    for (const i of this._def.checks)
      i.kind === "int" ? T.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? Zi(e.data, i.value) !== 0 && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.not_finite,
        message: i.message
      }), r.dirty()) : T.assertNever(i);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, m.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, m.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, m.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, m.toString(n));
  }
  setLimit(e, n, s, r) {
    return new se({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: m.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new se({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: m.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: m.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: m.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: m.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && T.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (n === null || s.value > n) && (n = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
se.create = (t) => new se({
  checks: [],
  typeName: g.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ..._(t)
});
class re extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== p.bigint) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: p.bigint,
        received: i.parsedType
      }), v;
    }
    let s;
    const r = new D();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : T.assertNever(i);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, m.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, m.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, m.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, m.toString(n));
  }
  setLimit(e, n, s, r) {
    return new re({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: m.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new re({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
re.create = (t) => {
  var e;
  return new re({
    checks: [],
    typeName: g.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ..._(t)
  });
};
class Ee extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== p.boolean) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.boolean,
        received: s.parsedType
      }), v;
    }
    return V(e.data);
  }
}
Ee.create = (t) => new Ee({
  typeName: g.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ..._(t)
});
class he extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== p.date) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: p.date,
        received: i.parsedType
      }), v;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_date
      }), v;
    }
    const s = new D();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: d.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), s.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: d.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), s.dirty()) : T.assertNever(i);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new he({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: m.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: m.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
he.create = (t) => new he({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: g.ZodDate,
  ..._(t)
});
class tt extends b {
  _parse(e) {
    if (this._getType(e) !== p.symbol) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.symbol,
        received: s.parsedType
      }), v;
    }
    return V(e.data);
  }
}
tt.create = (t) => new tt({
  typeName: g.ZodSymbol,
  ..._(t)
});
class Re extends b {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.undefined,
        received: s.parsedType
      }), v;
    }
    return V(e.data);
  }
}
Re.create = (t) => new Re({
  typeName: g.ZodUndefined,
  ..._(t)
});
class Ne extends b {
  _parse(e) {
    if (this._getType(e) !== p.null) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.null,
        received: s.parsedType
      }), v;
    }
    return V(e.data);
  }
}
Ne.create = (t) => new Ne({
  typeName: g.ZodNull,
  ..._(t)
});
class xe extends b {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return V(e.data);
  }
}
xe.create = (t) => new xe({
  typeName: g.ZodAny,
  ..._(t)
});
class ue extends b {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return V(e.data);
  }
}
ue.create = (t) => new ue({
  typeName: g.ZodUnknown,
  ..._(t)
});
class ee extends b {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return h(n, {
      code: d.invalid_type,
      expected: p.never,
      received: n.parsedType
    }), v;
  }
}
ee.create = (t) => new ee({
  typeName: g.ZodNever,
  ..._(t)
});
class nt extends b {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.void,
        received: s.parsedType
      }), v;
    }
    return V(e.data);
  }
}
nt.create = (t) => new nt({
  typeName: g.ZodVoid,
  ..._(t)
});
class B extends b {
  _parse(e) {
    const { ctx: n, status: s } = this._processInputParams(e), r = this._def;
    if (n.parsedType !== p.array)
      return h(n, {
        code: d.invalid_type,
        expected: p.array,
        received: n.parsedType
      }), v;
    if (r.exactLength !== null) {
      const a = n.data.length > r.exactLength.value, o = n.data.length < r.exactLength.value;
      (a || o) && (h(n, {
        code: a ? d.too_big : d.too_small,
        minimum: o ? r.exactLength.value : void 0,
        maximum: a ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), s.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (h(n, {
      code: d.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), s.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (h(n, {
      code: d.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), s.dirty()), n.common.async)
      return Promise.all([...n.data].map((a, o) => r.type._parseAsync(new q(n, a, n.path, o)))).then((a) => D.mergeArray(s, a));
    const i = [...n.data].map((a, o) => r.type._parseSync(new q(n, a, n.path, o)));
    return D.mergeArray(s, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new B({
      ...this._def,
      minLength: { value: e, message: m.toString(n) }
    });
  }
  max(e, n) {
    return new B({
      ...this._def,
      maxLength: { value: e, message: m.toString(n) }
    });
  }
  length(e, n) {
    return new B({
      ...this._def,
      exactLength: { value: e, message: m.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
B.create = (t, e) => new B({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g.ZodArray,
  ..._(e)
});
function me(t) {
  if (t instanceof M) {
    const e = {};
    for (const n in t.shape) {
      const s = t.shape[n];
      e[n] = K.create(me(s));
    }
    return new M({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof B ? new B({
      ...t._def,
      type: me(t.element)
    }) : t instanceof K ? K.create(me(t.unwrap())) : t instanceof ae ? ae.create(me(t.unwrap())) : t instanceof G ? G.create(t.items.map((e) => me(e))) : t;
}
class M extends b {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = T.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== p.object) {
      const l = this._getOrReturnCtx(e);
      return h(l, {
        code: d.invalid_type,
        expected: p.object,
        received: l.parsedType
      }), v;
    }
    const { status: s, ctx: r } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ee && this._def.unknownKeys === "strip"))
      for (const l in r.data)
        a.includes(l) || o.push(l);
    const c = [];
    for (const l of a) {
      const u = i[l], f = r.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new q(r, f, r.path, l)),
        alwaysSet: l in r.data
      });
    }
    if (this._def.catchall instanceof ee) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of o)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: r.data[u] }
          });
      else if (l === "strict")
        o.length > 0 && (h(r, {
          code: d.unrecognized_keys,
          keys: o
        }), s.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of o) {
        const f = r.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new q(r, f, r.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const f = await u.key, y = await u.value;
        l.push({
          key: f,
          value: y,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => D.mergeObjectSync(s, l)) : D.mergeObjectSync(s, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return m.errToObj, new M({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, s) => {
          var r, i, a, o;
          const c = (a = (i = (r = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(r, n, s).message) !== null && a !== void 0 ? a : s.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (o = m.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new M({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new M({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new M({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new M({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new M({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return T.objectKeys(e).forEach((s) => {
      e[s] && this.shape[s] && (n[s] = this.shape[s]);
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return T.objectKeys(this.shape).forEach((s) => {
      e[s] || (n[s] = this.shape[s]);
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return me(this);
  }
  partial(e) {
    const n = {};
    return T.objectKeys(this.shape).forEach((s) => {
      const r = this.shape[s];
      e && !e[s] ? n[s] = r : n[s] = r.optional();
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return T.objectKeys(this.shape).forEach((s) => {
      if (e && !e[s])
        n[s] = this.shape[s];
      else {
        let i = this.shape[s];
        for (; i instanceof K; )
          i = i._def.innerType;
        n[s] = i;
      }
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Wn(T.objectKeys(this.shape));
  }
}
M.create = (t, e) => new M({
  shape: () => t,
  unknownKeys: "strip",
  catchall: ee.create(),
  typeName: g.ZodObject,
  ..._(e)
});
M.strictCreate = (t, e) => new M({
  shape: () => t,
  unknownKeys: "strict",
  catchall: ee.create(),
  typeName: g.ZodObject,
  ..._(e)
});
M.lazycreate = (t, e) => new M({
  shape: t,
  unknownKeys: "strip",
  catchall: ee.create(),
  typeName: g.ZodObject,
  ..._(e)
});
class Ze extends b {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = this._def.options;
    function r(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new P(o.ctx.common.issues));
      return h(n, {
        code: d.invalid_union,
        unionErrors: a
      }), v;
    }
    if (n.common.async)
      return Promise.all(s.map(async (i) => {
        const a = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: a
          }),
          ctx: a
        };
      })).then(r);
    {
      let i;
      const a = [];
      for (const c of s) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: l }), l.common.issues.length && a.push(l.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((c) => new P(c));
      return h(n, {
        code: d.invalid_union,
        unionErrors: o
      }), v;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ze.create = (t, e) => new Ze({
  options: t,
  typeName: g.ZodUnion,
  ..._(e)
});
const H = (t) => t instanceof Ve ? H(t.schema) : t instanceof F ? H(t.innerType()) : t instanceof Pe ? [t.value] : t instanceof ie ? t.options : t instanceof je ? T.objectValues(t.enum) : t instanceof $e ? H(t._def.innerType) : t instanceof Re ? [void 0] : t instanceof Ne ? [null] : t instanceof K ? [void 0, ...H(t.unwrap())] : t instanceof ae ? [null, ...H(t.unwrap())] : t instanceof Bt || t instanceof ze ? H(t.unwrap()) : t instanceof Le ? H(t._def.innerType) : [];
class ot extends b {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.object)
      return h(n, {
        code: d.invalid_type,
        expected: p.object,
        received: n.parsedType
      }), v;
    const s = this.discriminator, r = n.data[s], i = this.optionsMap.get(r);
    return i ? n.common.async ? i._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : i._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (h(n, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [s]
    }), v);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, s) {
    const r = /* @__PURE__ */ new Map();
    for (const i of n) {
      const a = H(i.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (r.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        r.set(o, i);
      }
    }
    return new ot({
      typeName: g.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: r,
      ..._(s)
    });
  }
}
function Ot(t, e) {
  const n = te(t), s = te(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === p.object && s === p.object) {
    const r = T.objectKeys(e), i = T.objectKeys(t).filter((o) => r.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of i) {
      const c = Ot(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      a[o] = c.data;
    }
    return { valid: !0, data: a };
  } else if (n === p.array && s === p.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < t.length; i++) {
      const a = t[i], o = e[i], c = Ot(a, o);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else
    return n === p.date && s === p.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Ie extends b {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), r = (i, a) => {
      if (At(i) || At(a))
        return v;
      const o = Ot(i.value, a.value);
      return o.valid ? ((Ct(i) || Ct(a)) && n.dirty(), { status: n.value, value: o.data }) : (h(s, {
        code: d.invalid_intersection_types
      }), v);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([i, a]) => r(i, a)) : r(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
Ie.create = (t, e, n) => new Ie({
  left: t,
  right: e,
  typeName: g.ZodIntersection,
  ..._(n)
});
class G extends b {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.array)
      return h(s, {
        code: d.invalid_type,
        expected: p.array,
        received: s.parsedType
      }), v;
    if (s.data.length < this._def.items.length)
      return h(s, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), v;
    !this._def.rest && s.data.length > this._def.items.length && (h(s, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...s.data].map((a, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new q(s, a, s.path, o)) : null;
    }).filter((a) => !!a);
    return s.common.async ? Promise.all(i).then((a) => D.mergeArray(n, a)) : D.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new G({
      ...this._def,
      rest: e
    });
  }
}
G.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new G({
    items: t,
    typeName: g.ZodTuple,
    rest: null,
    ..._(e)
  });
};
class De extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.object)
      return h(s, {
        code: d.invalid_type,
        expected: p.object,
        received: s.parsedType
      }), v;
    const r = [], i = this._def.keyType, a = this._def.valueType;
    for (const o in s.data)
      r.push({
        key: i._parse(new q(s, o, s.path, o)),
        value: a._parse(new q(s, s.data[o], s.path, o)),
        alwaysSet: o in s.data
      });
    return s.common.async ? D.mergeObjectAsync(n, r) : D.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, s) {
    return n instanceof b ? new De({
      keyType: e,
      valueType: n,
      typeName: g.ZodRecord,
      ..._(s)
    }) : new De({
      keyType: z.create(),
      valueType: e,
      typeName: g.ZodRecord,
      ..._(n)
    });
  }
}
class st extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.map)
      return h(s, {
        code: d.invalid_type,
        expected: p.map,
        received: s.parsedType
      }), v;
    const r = this._def.keyType, i = this._def.valueType, a = [...s.data.entries()].map(([o, c], l) => ({
      key: r._parse(new q(s, o, s.path, [l, "key"])),
      value: i._parse(new q(s, c, s.path, [l, "value"]))
    }));
    if (s.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return v;
          (l.status === "dirty" || u.status === "dirty") && n.dirty(), o.set(l.value, u.value);
        }
        return { status: n.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of a) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return v;
        (l.status === "dirty" || u.status === "dirty") && n.dirty(), o.set(l.value, u.value);
      }
      return { status: n.value, value: o };
    }
  }
}
st.create = (t, e, n) => new st({
  valueType: e,
  keyType: t,
  typeName: g.ZodMap,
  ..._(n)
});
class pe extends b {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== p.set)
      return h(s, {
        code: d.invalid_type,
        expected: p.set,
        received: s.parsedType
      }), v;
    const r = this._def;
    r.minSize !== null && s.data.size < r.minSize.value && (h(s, {
      code: d.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && s.data.size > r.maxSize.value && (h(s, {
      code: d.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function a(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return v;
        u.status === "dirty" && n.dirty(), l.add(u.value);
      }
      return { status: n.value, value: l };
    }
    const o = [...s.data.values()].map((c, l) => i._parse(new q(s, c, s.path, l)));
    return s.common.async ? Promise.all(o).then((c) => a(c)) : a(o);
  }
  min(e, n) {
    return new pe({
      ...this._def,
      minSize: { value: e, message: m.toString(n) }
    });
  }
  max(e, n) {
    return new pe({
      ...this._def,
      maxSize: { value: e, message: m.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
pe.create = (t, e) => new pe({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: g.ZodSet,
  ..._(e)
});
class _e extends b {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.function)
      return h(n, {
        code: d.invalid_type,
        expected: p.function,
        received: n.parsedType
      }), v;
    function s(o, c) {
      return Qe({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Xe(),
          be
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function r(o, c) {
      return Qe({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Xe(),
          be
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const i = { errorMap: n.common.contextualErrorMap }, a = n.data;
    if (this._def.returns instanceof Te) {
      const o = this;
      return V(async function(...c) {
        const l = new P([]), u = await o._def.args.parseAsync(c, i).catch((S) => {
          throw l.addIssue(s(c, S)), l;
        }), f = await Reflect.apply(a, this, u);
        return await o._def.returns._def.type.parseAsync(f, i).catch((S) => {
          throw l.addIssue(r(f, S)), l;
        });
      });
    } else {
      const o = this;
      return V(function(...c) {
        const l = o._def.args.safeParse(c, i);
        if (!l.success)
          throw new P([s(c, l.error)]);
        const u = Reflect.apply(a, this, l.data), f = o._def.returns.safeParse(u, i);
        if (!f.success)
          throw new P([r(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new _e({
      ...this._def,
      args: G.create(e).rest(ue.create())
    });
  }
  returns(e) {
    return new _e({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, s) {
    return new _e({
      args: e || G.create([]).rest(ue.create()),
      returns: n || ue.create(),
      typeName: g.ZodFunction,
      ..._(s)
    });
  }
}
class Ve extends b {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Ve.create = (t, e) => new Ve({
  getter: t,
  typeName: g.ZodLazy,
  ..._(e)
});
class Pe extends b {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        received: n.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), v;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Pe.create = (t, e) => new Pe({
  value: t,
  typeName: g.ZodLiteral,
  ..._(e)
});
function Wn(t, e) {
  return new ie({
    values: t,
    typeName: g.ZodEnum,
    ..._(e)
  });
}
class ie extends b {
  constructor() {
    super(...arguments), Se.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return h(n, {
        expected: T.joinValues(s),
        received: n.parsedType,
        code: d.invalid_type
      }), v;
    }
    if (et(this, Se, "f") || zn(this, Se, new Set(this._def.values), "f"), !et(this, Se, "f").has(e.data)) {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return h(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: s
      }), v;
    }
    return V(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return ie.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return ie.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...n
    });
  }
}
Se = /* @__PURE__ */ new WeakMap();
ie.create = Wn;
class je extends b {
  constructor() {
    super(...arguments), Ae.set(this, void 0);
  }
  _parse(e) {
    const n = T.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== p.string && s.parsedType !== p.number) {
      const r = T.objectValues(n);
      return h(s, {
        expected: T.joinValues(r),
        received: s.parsedType,
        code: d.invalid_type
      }), v;
    }
    if (et(this, Ae, "f") || zn(this, Ae, new Set(T.getValidEnumValues(this._def.values)), "f"), !et(this, Ae, "f").has(e.data)) {
      const r = T.objectValues(n);
      return h(s, {
        received: s.data,
        code: d.invalid_enum_value,
        options: r
      }), v;
    }
    return V(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ae = /* @__PURE__ */ new WeakMap();
je.create = (t, e) => new je({
  values: t,
  typeName: g.ZodNativeEnum,
  ..._(e)
});
class Te extends b {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.promise && n.common.async === !1)
      return h(n, {
        code: d.invalid_type,
        expected: p.promise,
        received: n.parsedType
      }), v;
    const s = n.parsedType === p.promise ? n.data : Promise.resolve(n.data);
    return V(s.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Te.create = (t, e) => new Te({
  type: t,
  typeName: g.ZodPromise,
  ..._(e)
});
class F extends b {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), r = this._def.effect || null, i = {
      addIssue: (a) => {
        h(s, a), a.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const a = r.transform(s.data, i);
      if (s.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (n.value === "aborted")
            return v;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: s.path,
            parent: s
          });
          return c.status === "aborted" ? v : c.status === "dirty" || n.value === "dirty" ? ve(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return v;
        const o = this._def.schema._parseSync({
          data: a,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? v : o.status === "dirty" || n.value === "dirty" ? ve(o.value) : o;
      }
    }
    if (r.type === "refinement") {
      const a = (o) => {
        const c = r.refinement(o, i);
        if (s.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? v : (o.status === "dirty" && n.dirty(), a(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => o.status === "aborted" ? v : (o.status === "dirty" && n.dirty(), a(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (r.type === "transform")
      if (s.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!Oe(a))
          return a;
        const o = r.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((a) => Oe(a) ? Promise.resolve(r.transform(a.value, i)).then((o) => ({ status: n.value, value: o })) : a);
    T.assertNever(r);
  }
}
F.create = (t, e, n) => new F({
  schema: t,
  typeName: g.ZodEffects,
  effect: e,
  ..._(n)
});
F.createWithPreprocess = (t, e, n) => new F({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: g.ZodEffects,
  ..._(n)
});
class K extends b {
  _parse(e) {
    return this._getType(e) === p.undefined ? V(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
K.create = (t, e) => new K({
  innerType: t,
  typeName: g.ZodOptional,
  ..._(e)
});
class ae extends b {
  _parse(e) {
    return this._getType(e) === p.null ? V(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ae.create = (t, e) => new ae({
  innerType: t,
  typeName: g.ZodNullable,
  ..._(e)
});
class $e extends b {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let s = n.data;
    return n.parsedType === p.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
$e.create = (t, e) => new $e({
  innerType: t,
  typeName: g.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
class Le extends b {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return Me(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new P(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new P(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Le.create = (t, e) => new Le({
  innerType: t,
  typeName: g.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
class rt extends b {
  _parse(e) {
    if (this._getType(e) !== p.nan) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        code: d.invalid_type,
        expected: p.nan,
        received: s.parsedType
      }), v;
    }
    return { status: "valid", value: e.data };
  }
}
rt.create = (t) => new rt({
  typeName: g.ZodNaN,
  ..._(t)
});
const Ii = Symbol("zod_brand");
class Bt extends b {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = n.data;
    return this._def.type._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ue extends b {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return i.status === "aborted" ? v : i.status === "dirty" ? (n.dirty(), ve(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return r.status === "aborted" ? v : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, n) {
    return new Ue({
      in: e,
      out: n,
      typeName: g.ZodPipeline
    });
  }
}
class ze extends b {
  _parse(e) {
    const n = this._def.innerType._parse(e), s = (r) => (Oe(r) && (r.value = Object.freeze(r.value)), r);
    return Me(n) ? n.then((r) => s(r)) : s(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ze.create = (t, e) => new ze({
  innerType: t,
  typeName: g.ZodReadonly,
  ..._(e)
});
function Kn(t, e = {}, n) {
  return t ? xe.create().superRefine((s, r) => {
    var i, a;
    if (!t(s)) {
      const o = typeof e == "function" ? e(s) : typeof e == "string" ? { message: e } : e, c = (a = (i = o.fatal) !== null && i !== void 0 ? i : n) !== null && a !== void 0 ? a : !0, l = typeof o == "string" ? { message: o } : o;
      r.addIssue({ code: "custom", ...l, fatal: c });
    }
  }) : xe.create();
}
const Di = {
  object: M.lazycreate
};
var g;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(g || (g = {}));
const Vi = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Kn((n) => n instanceof t, e), qn = z.create, Gn = se.create, Pi = rt.create, ji = re.create, Yn = Ee.create, $i = he.create, Li = tt.create, zi = Re.create, Bi = Ne.create, Fi = xe.create, Ui = ue.create, Wi = ee.create, Ki = nt.create, qi = B.create, Gi = M.create, Yi = M.strictCreate, Hi = Ze.create, Ji = ot.create, Xi = Ie.create, Qi = G.create, ea = De.create, ta = st.create, na = pe.create, sa = _e.create, ra = Ve.create, ia = Pe.create, aa = ie.create, oa = je.create, ca = Te.create, rn = F.create, ua = K.create, la = ae.create, da = F.createWithPreprocess, fa = Ue.create, ha = () => qn().optional(), pa = () => Gn().optional(), ma = () => Yn().optional(), ya = {
  string: (t) => z.create({ ...t, coerce: !0 }),
  number: (t) => se.create({ ...t, coerce: !0 }),
  boolean: (t) => Ee.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => re.create({ ...t, coerce: !0 }),
  date: (t) => he.create({ ...t, coerce: !0 })
}, ga = v;
var U = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: be,
  setErrorMap: gi,
  getErrorMap: Xe,
  makeIssue: Qe,
  EMPTY_PATH: vi,
  addIssueToContext: h,
  ParseStatus: D,
  INVALID: v,
  DIRTY: ve,
  OK: V,
  isAborted: At,
  isDirty: Ct,
  isValid: Oe,
  isAsync: Me,
  get util() {
    return T;
  },
  get objectUtil() {
    return St;
  },
  ZodParsedType: p,
  getParsedType: te,
  ZodType: b,
  datetimeRegex: Un,
  ZodString: z,
  ZodNumber: se,
  ZodBigInt: re,
  ZodBoolean: Ee,
  ZodDate: he,
  ZodSymbol: tt,
  ZodUndefined: Re,
  ZodNull: Ne,
  ZodAny: xe,
  ZodUnknown: ue,
  ZodNever: ee,
  ZodVoid: nt,
  ZodArray: B,
  ZodObject: M,
  ZodUnion: Ze,
  ZodDiscriminatedUnion: ot,
  ZodIntersection: Ie,
  ZodTuple: G,
  ZodRecord: De,
  ZodMap: st,
  ZodSet: pe,
  ZodFunction: _e,
  ZodLazy: Ve,
  ZodLiteral: Pe,
  ZodEnum: ie,
  ZodNativeEnum: je,
  ZodPromise: Te,
  ZodEffects: F,
  ZodTransformer: F,
  ZodOptional: K,
  ZodNullable: ae,
  ZodDefault: $e,
  ZodCatch: Le,
  ZodNaN: rt,
  BRAND: Ii,
  ZodBranded: Bt,
  ZodPipeline: Ue,
  ZodReadonly: ze,
  custom: Kn,
  Schema: b,
  ZodSchema: b,
  late: Di,
  get ZodFirstPartyTypeKind() {
    return g;
  },
  coerce: ya,
  any: Fi,
  array: qi,
  bigint: ji,
  boolean: Yn,
  date: $i,
  discriminatedUnion: Ji,
  effect: rn,
  enum: aa,
  function: sa,
  instanceof: Vi,
  intersection: Xi,
  lazy: ra,
  literal: ia,
  map: ta,
  nan: Pi,
  nativeEnum: oa,
  never: Wi,
  null: Bi,
  nullable: la,
  number: Gn,
  object: Gi,
  oboolean: ma,
  onumber: pa,
  optional: ua,
  ostring: ha,
  pipeline: fa,
  preprocess: da,
  promise: ca,
  record: ea,
  set: na,
  strictObject: Yi,
  string: qn,
  symbol: Li,
  transformer: rn,
  tuple: Qi,
  undefined: zi,
  union: Hi,
  unknown: Ui,
  void: Ki,
  NEVER: ga,
  ZodIssueCode: d,
  quotelessJson: yi,
  ZodError: P
});
const Aa = U.union([
  U.literal("mobile"),
  U.literal("tablet"),
  U.literal("desktop"),
  U.array(U.enum(["mobile", "tablet", "desktop"]))
]).optional();
function va(t) {
  return Qn(() => {
    const n = {
      "data-screen-mobile": "hidden",
      "data-screen-tablet": "hidden",
      "data-screen-desktop": "hidden"
    };
    return t ? (Array.isArray(t) ? t : [t]).forEach((r) => {
      r === "mobile" ? n["data-screen-mobile"] = "visible" : r === "tablet" ? n["data-screen-tablet"] = "visible" : r === "desktop" && (n["data-screen-desktop"] = "visible");
    }) : (n["data-screen-mobile"] = "visible", n["data-screen-tablet"] = "visible", n["data-screen-desktop"] = "visible"), n;
  }, [t]);
}
const _a = U.object({
  mobile: U.boolean().nullable().optional(),
  tablet: U.boolean().nullable().optional(),
  desktop: U.boolean().nullable().optional()
}).optional(), ba = _a.transform((t) => {
  if (!t || Object.keys(t).length === 0)
    return ["mobile", "tablet", "desktop"];
  const { mobile: e = !1, tablet: n = e, desktop: s = !1 } = t;
  return [
    e && "mobile",
    n && "tablet",
    s && "desktop"
  ].filter(Boolean);
}).optional();
function Ca(t) {
  const e = ba.parse(t);
  return va(e);
}
const ht = (t) => {
  const [e, n] = it(!1);
  return le(() => {
    const s = window.matchMedia(t);
    n(s.matches);
    const r = (i) => n(i.matches);
    return s.addEventListener("change", r), () => s.removeEventListener("change", r);
  }, [t]), e;
}, Oa = () => {
  const t = {
    mobile: ht("(max-width: 767px)"),
    tablet: ht("(min-width: 768px) and (max-width: 1024px)"),
    desktop: ht("(min-width: 1025px)"),
    active: ""
  };
  switch (!0) {
    case t.mobile:
      t.active = "mobile";
      break;
    case t.tablet:
      t.active = "tablet";
      break;
    case t.desktop:
      t.active = "desktop";
      break;
  }
  return t;
}, xa = 500;
function Ma(t, e) {
  const [n, s] = it(t);
  return le(() => {
    const r = setTimeout(
      () => s(t),
      e || xa
    );
    return () => {
      clearTimeout(r);
    };
  }, [t, e]), n;
}
const Ea = (t) => {
  le(() => {
    const e = (n) => {
      n.key === "Escape" && t();
    };
    return document.addEventListener("keydown", e), () => {
      document.removeEventListener("keydown", e);
    };
  }, [t]);
};
export {
  _a as breakpointVisibilitySchema,
  Aa as breakpointsSchema,
  Sa as useBoop,
  Oa as useBreakpoint,
  va as useBreakpointDataAttributes,
  Ca as useBreakpointVisibility,
  Ma as useDebounce,
  Ea as useEscKey,
  ht as useMediaQuery,
  mi as usePrefersReducedMotion
};
